import {ChangeDetectorRef, Component} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {ElementRef} from '@angular/core';
import {SubFormComponent} from '../../_subform';
import {environment} from '@environments/environment';

/*
* Блок с соглашениями на обработку данных и правил хранения
* */

@Component({
    providers: [
    ],
    selector: 'specialist-form-fields-agreements',
    templateUrl: './specialist-form-fields-agreements.component.html'
})
export class SpecialistFormFieldsAgreementsComponent extends SubFormComponent {

    legalUrl = environment.legalRulesUrl;

    public formGroupTemplate = this._fb.group({
        personalDataAgreement: [false], // Согласие на обработку данных
        dataStoringAgreement: [false] // Ознакомлен с правилами хранения
    });

    constructor(
        public elementRef: ElementRef,
        private changeDetectionRef: ChangeDetectorRef,
        private _fb: FormBuilder
    ) {
        super();
    }
}
